import {
  jb_lazy_loading_uploads_css_default
} from "./chunk.5TCET7OM.js";
import {
  reset_css_default
} from "./chunk.PBU2AIHD.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  ke,
  r
} from "./chunk.NBIYIO67.js";
import {
  __decorateClass
} from "./chunk.2QRLEY22.js";

// src/components/jb-lazy-loading-uploads/jb-lazy-loading-uploads.ts
var JbLazyLoadingUploads = class extends r {
  firstUpdated() {
    this._uploads = Array.from(this.querySelectorAll("jb-upload"));
    this._showFilledPlusOneEmpty();
  }
  _showFilledPlusOneEmpty() {
    this._uploads.forEach((upload) => {
      upload.style.display = "none";
    });
    this._uploads.filter((upload) => upload.isUploaded).forEach((upload) => {
      upload.style.display = "initial";
    });
    const firstEmptyField = this._uploads.filter((upload) => !upload.isUploaded).shift();
    if (firstEmptyField) {
      firstEmptyField.style.display = "initial";
    }
  }
  render() {
    return ke`<section><slot @jb-upload:field-change=${this._showFilledPlusOneEmpty}></slot></section>`;
  }
};
JbLazyLoadingUploads.styles = [reset_css_default, jb_lazy_loading_uploads_css_default];
JbLazyLoadingUploads = __decorateClass([
  customElement("jb-lazy-loading-uploads")
], JbLazyLoadingUploads);

export {
  JbLazyLoadingUploads
};
